<template>
  <v-card class="fill-height">
    <ORow fill-xy top>
      <OCol class="oderon-col-2 pa-2">
        <v-card>
          <v-toolbar flat class="card-bar">
            <v-toolbar-title>CAN Sniff</v-toolbar-title>
            <v-spacer />
            <v-dialog width="800">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon>
                  <v-icon>mdi-information-outline</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>Sintaxe de Plot Configs</v-card-title>
                <v-card-text
                  ><pre>{{ help }}</pre></v-card-text
                >
              </v-card>
            </v-dialog>
            <OMenuButton :menuOpts="menuOpts" />
          </v-toolbar>

          <v-card-text>
            <v-textarea
              label="Plot Configs"
              class="monospace-input"
              v-model="strPlotConfigs"
              rows="10"
            />
          </v-card-text>
          <v-card-actions class="pa-6">
            <v-btn block color="primary" @click="generatePlots">
              Regerar Gráficos
            </v-btn>
          </v-card-actions>
        </v-card>
      </OCol>
      <OCol class="oderon-col-10 pa-2 plots-overflow-container">
        <ORow fill-x>
          <v-card class="fill-width">
            <v-card-text class="fill-width">
              <div class="caret-timestamp">&nbsp;</div>
              <div v-if="pinned.length < 1">
                (Não existem plots fixados)
              </div>
              <Plot
                v-for="config in pinned"
                :key="config.id"
                :config="config"
              />
            </v-card-text>
          </v-card>
        </ORow>
        <OCol fill-x style="overflow-y: scroll">
          <div class="pa-4 fill-width">
            <Plot v-for="config in other" :key="config.id" :config="config" />
          </div>
        </OCol>
      </OCol>
    </ORow>
  </v-card>
</template>

<script>
import SniffStore from './can-sniff/SniffStore.js'
import Plot from './can-sniff/Plot.vue'

const help = `
rpm                        variável de rawdata
speed                      variável de rawdata
-----                      separador de plots fixados
000c00 08 16               variável de can-sniff (bits 8 a 15 inclusive)
00aa00 16 24 08 16         ajuste endian-ness (bits 16-23 e depois 8-15)

Variáveis de rawdata:
rpm
speed
accelerometer
brake
dg1
dg2
dg3
buzz
act
incOdo
notFix
state
polygon
gps
speedFromGps
rpmFromAccel
an1
an2
an3
an4
`.trim()

export default {
  components: { Plot },
  data() {
    return { help }
  },
  computed: {
    strPlotConfigs: {
      get() {
        return SniffStore.strPlotConfigs
      },
      set(x) {
        SniffStore.strPlotConfigs = x
      }
    },
    pinned() {
      return SniffStore.pinnedPlots
    },
    other() {
      return SniffStore.otherPlots
    },

    // debug apenas
    theStore() {
      return SniffStore
    },

    menuOpts() {
      return [
        { text: 'Preencher com defaults', onClick: this.fillWithDefaults }
      ]
    }
  },
  methods: {
    generatePlots() {
      SniffStore.parsePlotConfigs()
      SniffStore.prepareD3()

      this.$nextTick(() => {
        SniffStore.plugZoomListeners()
        SniffStore.redraw()
      })
    },

    fillWithDefaults() {
      const { totalVars, totalPlots, addedCount } = SniffStore.fillPlotConfigs()
      const msg = `Adicionados ${addedCount} de (${totalVars} * 8 == ${totalPlots}) plots`
      this.$snack(msg)
    },

    // copyToClipboard() {
    //   navigator.clipboard.writeText(this.formattedBytes)
    //   this.$snack(`Copiado para a área de transferência`)
    // },

    showRowDetails(row) {
      this.$refs.dialog.open(row)
    }
  }
}
</script>

<style lang="sass">
.plots-overflow-container
  height: calc(100vh - 128px)
  display: flex
  flex-flow: column
  overflow-y: hidden

.caret-timestamp
  text-align: center
</style>
